import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { ConsultaReembolsoListComp } from 'pages/financeiro/reembolso/consulta-reembolso/components';
import { ConsultaReembolsoProvider } from 'pages/financeiro/reembolso/consulta-reembolso/contexts';

export function ConsultaReembolsoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['FINANCEIRO_REEMBOLSO_CONSULTAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <ConsultaReembolsoProvider>
                <ConsultaReembolsoListComp />
            </ConsultaReembolsoProvider>
        </ListagemProvider>
    );
}
